var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegistrationComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81,
    height: 78,
    viewBox: "0 0 81 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .018h48.741v48.856H.001z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 78,
    fill: "#00893F",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7FC49F",
    d: "M67 43.836c0 10.004-7.992 18.112-17.852 18.112-9.859 0-17.852-8.108-17.852-18.112 0-10.003 7.993-18.112 17.852-18.112 9.86 0 17.852 8.11 17.852 18.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M26.551 30.834h18.231a.744.744 0 0 0 .737-.752c0-.415-.33-.75-.737-.75H26.551a.744.744 0 0 0-.736.75c0 .416.33.752.736.752M20.634 30.834h1.472a.749.749 0 0 0 .746-.752.748.748 0 0 0-.746-.75h-1.472a.748.748 0 0 0-.745.75c0 .416.334.752.745.752M36.037 41.206h-9.481c-.41 0-.741.335-.741.75 0 .416.331.753.74.753h9.482c.41 0 .74-.337.74-.752a.745.745 0 0 0-.74-.751M20.634 42.709h1.472a.75.75 0 0 0 .746-.753.748.748 0 0 0-.746-.75h-1.472a.748.748 0 0 0-.745.75.75.75 0 0 0 .745.753M36.034 47.067h-9.476a.747.747 0 0 0-.743.752c0 .416.332.752.743.752h9.476c.41 0 .744-.336.744-.752a.748.748 0 0 0-.744-.752M20.634 48.57h1.472a.749.749 0 0 0 .746-.752.748.748 0 0 0-.746-.75h-1.472a.748.748 0 0 0-.745.75c0 .417.334.753.745.753M20.63 36.847h17.63c.408 0 .74-.336.74-.752a.747.747 0 0 0-.74-.751H20.63a.747.747 0 0 0-.741.751c0 .416.332.752.741.752M39.743 53.08H20.777a.746.746 0 0 0-.74.752c0 .415.331.75.74.75h18.966a.745.745 0 0 0 .738-.75.746.746 0 0 0-.738-.752"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 14)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M38.13 39.086c-5.035 0-9.133-4.146-9.133-9.242 0-5.097 4.098-9.243 9.134-9.243 5.035 0 9.134 4.146 9.134 9.243 0 5.096-4.099 9.242-9.134 9.242zM6.145 47.379V10.957h27.32a.743.743 0 0 0 .74-.748.742.742 0 0 0-.74-.747c-2.165 0-3.927-1.783-3.927-3.974 0-2.192 1.762-3.974 3.928-3.974s3.927 1.782 3.927 3.974v13.656c-5.506.387-9.872 5.03-9.872 10.7 0 5.667 4.366 10.313 9.872 10.7v6.835H6.144zM1.478 5.489c0-2.193 1.762-3.975 3.926-3.975h24.352a5.486 5.486 0 0 0-1.695 3.974c0 1.564.652 2.976 1.695 3.974H5.404c-2.164 0-3.926-1.783-3.926-3.974zM48.74 29.843c0-5.67-4.366-10.313-9.872-10.7V5.488c0-3.016-2.425-5.47-5.404-5.47H5.404C2.424.017 0 2.47 0 5.487c0 2.76 2.035 5.045 4.666 5.412v37.227c0 .413.331.747.738.747h32.727a.743.743 0 0 0 .738-.747v-7.584c5.506-.386 9.872-5.032 9.872-10.7z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M47.09 48.757a.862.862 0 0 1-.615-.254l-2.77-2.776a.872.872 0 0 1 0-1.23.866.866 0 0 1 1.227 0l2.157 2.161 6.367-6.379a.866.866 0 0 1 1.228 0 .87.87 0 0 1 0 1.23l-6.98 6.994a.862.862 0 0 1-.615.254"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationComplete);
export default __webpack_public_path__ + "static/media/registration-complete.48bfcfd19e8f91205e9588ac44ee4c63.svg";
export { ForwardRef as ReactComponent };